import { DatePipe } from '@angular/common';
import { Component, Input, inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { GridOptionsService } from '../../../columns/column-definition/grid-options.service';
import { OrdersApiClientService } from '../../../services/orders.api.client.service';
import { SnackbarService } from '../../../services/snackbar/snackbar.service';
import { CancelOrderDialogComponent } from '../cancel-order-dialog/cancel-order-dialog.component';

@Component({
  selector: 'app-cancel-order',
  templateUrl: './cancel-order.component.html',
  styleUrls: ['./cancel-order.component.scss'],
  standalone: false,
})
export class CancelOrderComponent {
  dialog = inject(MatDialog);
  private snackbar = inject(SnackbarService);
  private ordersService = inject(OrdersApiClientService);
  private gridOptionService = inject(GridOptionsService);
  private datePipe = inject(DatePipe);

  @Input() public orderId: string | undefined;
  @Input() public trademarkName: string | undefined;
  @Input() public cancelDate: string | undefined;
  @Input() public selectedCount: number | undefined;
  @Input() public disabled = false;
  @Input() public tooltipPosition: 'above' | 'below' | 'before' | 'after' =
    'below';

  get undoIconData(): { badgeIcon: string; toolTip: string } {
    return {
      badgeIcon: 'pending grey-color',
      toolTip: $localize`:@@CancelOrderUndoCancelIconTooltip:Undo cancellation scheduled for ${this.datePipe.transform(
        this.cancelDate,
        'dd MMM yyyy',
      )}`,
    };
  }

  showUndoIcon(): boolean {
    return !!(this.cancelDate && new Date(this.cancelDate) > new Date());
  }

  undoCancelOrder(): void {
    this.ordersService.undoOrderCancellation(this.orderId!).subscribe(() => {
      this.gridOptionService.refreshData(null, 'cancelDate', this.orderId!);
      this.snackbar.openSnackBar(
        $localize`:@@CancelOrderUndoSnackbar:Watch Order "${this.trademarkName}" is no longer scheduled to be canceled.`,
      );
    });
  }

  cancelOrder(): void {
    if (!this.disabled) {
      const title = `Cancel ${this.trademarkName}`;
      this.dialog.open(CancelOrderDialogComponent, {
        data: {
          title,
          orderId: this.orderId,
          selectedCount: this.selectedCount,
        },
        autoFocus: false,
        width: '45rem',
        position: { top: '6.43rem' },
      });
    }
  }
}
